export enum Role {
  admin = 'admin',
  entregador = 'entregador',
  vendedor = 'vendedor'
}